module.exports = __webpack_public_path__ + "img/2010 radtour ehrenabteilung 030.9f45a355.jpg";